import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { Button, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useNavigate } from "react-router-dom";
import { IOSSwitch } from "../../Gen/Switch";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import "./Product.css";
import { getProducts } from "../../../Store/Features/Product/productSlice";
import CircularProgress from '@mui/material/CircularProgress';
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
export const ProductTable = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const navigate = useNavigate();
  const Products = useSelector(state => state.productsSlice.value);
  const Loading = useSelector(state => state.productsSlice.loading);

  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  useEffect(() => {
    if (isObjEmpty(Products))
      dispatch(getProducts(slug));
  }, []);
  const columns = [
    { field: 'name', headerName: 'Product Name', flex: 1 },
    {
      field: 'price',
      headerName: 'Price',
      flex: 1,
      renderCell: (params) => (
        <Typography className="cellText">{getCurr(params.row.currency)} {params.row.price}</Typography>
      )

    },

    {
      field: 'sku',
      headerName: 'SKU',
      flex: 1,
      valueGetter: (params) =>
        `${params.row.sku || ''}`,
    },
    {
      field: "Active On Channel",
      flex: 1,
      headerAlign: "left",
      renderCell: (params) => (
        <div style={{ display: "flex", alignContent: "center", justifyContent: "flex-start", width: "100%" }}>
          <IOSSwitch className="statusbtn" checke={params.row.is_active == "1" ? true : false} sx={{ m: 1 }} defaultChecked />
        </div >
      ),
    },
    {
      field: ' ',
      headerName: '',
      flex: 1,
      renderCell: (params) => (
        <Button className="hover" sx={{ backgroundColor: "#ec492f", height: 28 }} onClick={() => navigate(`/Product/${params.row.id}`)}  >
          <Typography className="button">Manage</Typography>
        </Button >
      )
    },
  ];

  return (<>
    {Loading ? (<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "40vh" }} > <CircularProgress /></Box >) : (<Box className="Table">
      <DataGrid

        rows={Products}
        columns={columns}
        initialState={{
          ...Products.initialState,
          pagination: { paginationModel: { pageSize: 10 } },
        }}
        autoHeight
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>)
    };
  </>

  );
};

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination

      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      sx={{
        '& .Mui-selected': {
          backgroundColor: 'transparent !important',
          color: '#ec492f',
        },
      }}
      renderItem={(props2) => <PaginationItem className="paginationText"  {...props2} />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

const getCurr = (currency) => {
  switch (currency) {
    case "GBP":
      return "£";
    case "USD":
      return "$";
    default:
      return "£";
  }
};
